export const REACT_APP_APIS = process.env.REACT_APP_APIS;
//eslint-disable-next-line
export const EMAIL_VALIDATION = /^[\w-\.]+@([\w-])+\.+[\w-]{2,3}$/i;
export const PASSWORD_VALIDATION =
  /.{5,}/;
export const PASSWORD_MESSAGE =
  "Password must contain at least 5 or more characters";
